import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPdfLeftArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M657.493 316.16l-60.16-60.16-256 256 256 256 60.16-60.16-195.413-195.84z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPdfLeftArrow);
export default ForwardRef;
